import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, message } from 'antd';
import { ImportOutlined, CheckCircleOutlined } from '@ant-design/icons';
import api from '../services/auth';

const ImportPage = ({ isMobile }) => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imported, setImported] = useState(false);
  const [projectName, setProjectName] = useState('');

  const handleImport = async () => {
    if (!code) {
      message.error('无效的模板链接');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/projects/import-template', { templateCode: code });
      setProjectName(res.data.name);
      setImported(true);
      message.success(`项目「${res.data.name}」导入成功`);
    } catch (err) {
      message.error('导入失败: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: isMobile ? 20 : 60 }}>
      <Card style={{ borderRadius: 16, textAlign: 'center' }}>
        {imported ? (
          <div>
            <CheckCircleOutlined style={{ fontSize: 48, color: '#34C759', marginBottom: 16 }} />
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1d1d1f', marginBottom: 8 }}>
              导入成功
            </div>
            <div style={{ fontSize: 15, color: '#86868b', marginBottom: 24 }}>
              项目「{projectName}」已成功导入
            </div>
            <Button
              type="primary"
              size="large"
              onClick={() => navigate('/')}
              style={{ borderRadius: 12, fontWeight: 600, minWidth: 160 }}
            >
              开始使用
            </Button>
          </div>
        ) : (
          <div>
            <ImportOutlined style={{ fontSize: 48, color: '#007AFF', marginBottom: 16 }} />
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1d1d1f', marginBottom: 8 }}>
              导入项目模板
            </div>
            <div style={{ fontSize: 15, color: '#86868b', marginBottom: 24 }}>
              将导入完整的项目结构（含节点和统计配置）
            </div>
            <Button
              type="primary"
              icon={<ImportOutlined />}
              size="large"
              loading={loading}
              onClick={handleImport}
              style={{ borderRadius: 12, fontWeight: 600, minWidth: 160, height: 48, fontSize: 16 }}
            >
              确认导入
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default ImportPage;
